<template>
  <div class="market-progress">
    <div
      v-if="hasScales"
      class="market-progress--scales"
    >
      <span
        v-for="num in total"
        :key="num"
        class="scale-num"
        >{{ num - 1 }}{{ num === total ? '+' : '' }}</span
      >
    </div>
    <div class="market-progress--inner-wrap">
      <div class="market-progress--inner">
        <div
          class="inner-bar"
          :style="{
            width: Math.abs(x2 - x1) + 'px',
            left: Math.min(x1, x2) + 'px'
          }"
        />
        <div class="scale-ball-list">
          <i
            v-for="(num, index) in total"
            :key="num"
            class="scale-ball"
            :style="{
              left: (index / (total - 1)) * 100 + '%'
            }"
            :class="{
              active: isActive(index)
            }"
          />
        </div>
        <div
          :style="{
            left: x1 + 'px'
          }"
          class="market-progress--ball first"
          @touchstart="onTouchstart"
          @touchmove="onTouchmove"
          @touchend="onTouchend"
          @mousedown="onMousedown"
        />
        <div
          :style="{
            left: x2 + 'px'
          }"
          class="market-progress--ball second"
          @touchstart="onTouchstart"
          @touchmove="onTouchmove"
          @touchend="onTouchend"
          @mousedown="onMousedown"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MarketProgress',
  props: {
    total: {
      type: Number,
      default: 6
    },
    startIndex: {
      type: Number,
      default: 0
    },
    endIndex: {
      type: Number,
      default: 0
    },
    // 是否显示刻度
    hasScales: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      // 标记是否按下
      isDownOnBall: false,
      clientWidth: 0,
      x1: 0,
      x2: 0
    }
  },
  computed: {
    stepWidth() {
      return this.clientWidth / (this.total - 1)
    }
  },
  watch: {
    total() {
      this.$nextTick(this.init)
    }
  },
  mounted() {
    this.init()
  },
  activated() {
    this.$nextTick(() => {
      this.init()
    })
  },
  methods: {
    init() {
      this.clientWidth = this.$el.clientWidth
      this.x1 = this.stepWidth * this.startIndex
      this.x2 = this.stepWidth * this.endIndex
    },
    isActive(index) {
      const { x1, x2, stepWidth } = this
      const minIndex = Math.floor(Math.min(x1, x2) / stepWidth)
      const maxIndex = Math.floor(Math.max(x1, x2) / stepWidth)
      return index >= minIndex && index <= maxIndex
    },
    // 修正 x 的位置
    correctXpostion(dx) {
      return Math.round(dx / this.stepWidth) * this.stepWidth
    },
    onTouchstart() {
      this.isDownOnBall = true
    },
    onTouchmove(e) {
      if (this.isDownOnBall) {
        const { target, pageX, clientX } = e.touches[0]
        const x = pageX || clientX
        let dx = x - this.$el.offsetLeft
        dx = dx >= this.clientWidth ? this.clientWidth : dx
        dx = dx < 0 ? 0 : dx
        if (target.classList.contains('first')) {
          this.x1 = dx
        } else {
          this.x2 = dx
        }
      }
    },
    onTouchend(e) {
      if (this.isDownOnBall) {
        const { target } = e.changedTouches[0]
        let dx = e.changedTouches[0].pageX - this.$el.offsetLeft
        dx = dx >= this.clientWidth ? this.clientWidth : dx
        dx = dx < 0 ? 0 : dx

        this.$nextTick(() => {
          dx = this.correctXpostion(dx)
          if (target.classList.contains('first')) {
            this.x1 = dx
          } else {
            this.x2 = dx
          }
          this.emitPosition()
        })
        this.isDownOnBall = false
      }
    },
    onMousedown(e) {
      this.isDownOnBall = true
      this._currentBall = e.target
      document.addEventListener('mousemove', this.onMousemove)
      document.addEventListener('mouseup', this.onMouseup)
    },
    onMousemove(e) {
      if (this.isDownOnBall) {
        const { pageX, clientX } = e
        const x = pageX || clientX
        const { left } = this.$el.getBoundingClientRect()
        let dx = x - left
        dx = dx >= this.clientWidth ? this.clientWidth : dx
        dx = dx < 0 ? 0 : dx
        if (this._currentBall.classList.contains('first')) {
          this.x1 = dx
        } else {
          this.x2 = dx
        }
      }
    },
    onMouseup(e) {
      if (this.isDownOnBall) {
        const { left } = this.$el.getBoundingClientRect()
        let dx = e.pageX - left
        dx = dx >= this.clientWidth ? this.clientWidth : dx
        dx = dx < 0 ? 0 : dx

        this.$nextTick(() => {
          dx = this.correctXpostion(dx)
          if (this._currentBall.classList.contains('first')) {
            this.x1 = dx
          } else {
            this.x2 = dx
          }
          this.emitPosition()
          this.isDownOnBall = false
          this._currentBall = null
        })
      }
      document.removeEventListener('mousemove', this.onMousemove)
      document.removeEventListener('mouseup', this.onMouseup)
    },
    emitPosition() {
      const { x1, x2, stepWidth } = this
      const range = x1 < x2 ? [x1, x2] : [x2, x1]
      const res = [Math.round(range[0] / stepWidth), Math.round(range[1] / stepWidth)]
      this.$emit('change', res)
    }
  }
}
</script>

<style lang="less">
@import url('~wap/common/style/variable.less');

.market-progress {
  &--scales {
    display: flex;
    justify-content: space-between;
    color: #999;
    font-size: 10px;
    line-height: 14px;
  }

  .scale-num {
    flex: 2;
    text-align: center;

    &:first-child {
      flex: 1;
      transform: translateX(-50%);
    }

    &:last-child {
      flex: 1;
      transform: translateX(50%);
    }
  }

  &--inner-wrap {
    padding: 14px 0;
  }

  &--inner {
    position: relative;
    height: 4px;
    border-radius: 2px;
    background: #666;
  }

  .scale-ball-list {
    position: relative;
    display: flex;
    width: 100%;
    height: 100%;
    justify-content: space-between;

    .scale-ball {
      position: absolute;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      margin: -2px 0 0 -2px;
      background: #b3b3b3;

      &.active {
        background: #fff;
      }
    }
  }

  .inner-bar {
    position: absolute;
    top: -0;
    height: 4px;
    background: @primary;
  }

  &--ball {
    position: absolute;
    z-index: 100;
    top: -14px;
    padding: 8px;
    margin-left: -15px;

    &::before {
      display: block;
      width: 14px;
      height: 14px;
      border-radius: 50%;
      background: #ffca27;
      content: '';
    }

    &::after {
      position: absolute;
      top: 50%;
      left: 50%;
      display: block;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background: #fff;
      content: '';
      transform: translate(-50%, -50%);
    }
  }
}
</style>

<style lang="scss" scoped>
[data-mode='light'] {
  .market-progress {
    &--inner {
      background: #ccc;
    }

    .scale-ball-list {
      .scale-ball {
        background: #b3b3b3;

        &.active {
          background: #daaf2a;
        }
      }
    }

    .inner-bar {
      background: #ffca27;
    }
  }
}
</style>
